import type { EditorCommand } from '@atlaskit/editor-common/types/editor-command';

import type { SetMauiEmbedFinalizeStatusProps } from '../malleableUiPluginType';
import { ActionType, mauiDiagramPastePluginKey } from '../pm-plugins/maui-diagram-paste-plugin';

/**
 * Sets the finalize status for a MAUI whiteboard embed (by content id), driving
 * `MauiNativeEmbedBanner` visibility. Used by the Rovo remix finalizer.
 */
export const setMauiEmbedFinalizeStatus =
	({ contentId, status }: SetMauiEmbedFinalizeStatusProps): EditorCommand =>
	({ tr }) => {
		if (!contentId) {
			return null;
		}
		tr.setMeta(mauiDiagramPastePluginKey, {
			type: ActionType.EMBED_FINALIZE_STATUS_CHANGED,
			contentId,
			status,
		});
		return tr;
	};
